











import Vue from 'vue';
import store from '@/store';
export default Vue.extend({
  computed: {
    adminAccess(): boolean {
      return store.state.org.adminAccess;
    }
  }
});
